import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  GithubAuthProvider,
  signInWithPopup,
  signOut,
  UserCredential,
  Auth,
} from 'firebase/auth';

// firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();

/**
 * Signs in utility function.
 *
 * @returns Promise with user credential
 */
export const signInWithGoogle = async (): Promise<UserCredential> =>
  signInWithPopup(auth, googleProvider);

export const signInWithGithub = async (): Promise<UserCredential> =>
  signInWithPopup(auth, githubProvider);

/**
 * Signs out utility function.
 *
 * @returns Promise with void
 */
export const signOutFirebase = async (): Promise<void> => signOut(auth);

export default auth;
